/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
  // Function to process product labels
  function processProductLabels() {
    $('.product_label--wrapper .product_label__hidden').each(function(){
      var $id = $(this).data('id');
      var $content = $(this).html();
      
      // Ensure we have valid content before replacing
      if ($content && $content.trim() !== '') {
        if($('.CollectionMain .ProductItem[data-product-id="' + $id + '"] .ProductItem__LabelList').length) {
          $('.CollectionMain .ProductItem[data-product-id="' + $id + '"] .ProductItem__LabelList').html($content);
        }
      }
    });
    
    // Make prices visible
    $(".ProductItem__PriceList").css('visibility', '');
  }
  
  // Run the process immediately
  // processProductLabels();
  
  // // And run it again after a short delay to ensure everything is loaded
  // setTimeout(processProductLabels, 500);
});

// add to cart analytics
document.addEventListener('product:added', function(e) {
  const variant = e.detail.variant
  const product = e.detail.product

  const dataLayer = window.dataLayer || []
  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      items: [
      {
        item_id: product.handle,
        item_name: product.title,
        currency: "USD",
        price: variant.price / 100,
        quantity: 1
      }
      ]
    }
  })
})

// view product analytics
document.addEventListener('product:changed', function(e) {
  const product = e.detail.product

  const dataLayer = window.dataLayer || []
  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: 'view_item',
    ecommerce: {
      items: [
        {
          item_id: product.handle,
          item_name: product.title,
          currency: 'USD',
          price: product.price / 100,
          quantity: 1
        }
      ]
    }
  })
})
